var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarEmpty = function SvgStarEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFB800",
    d: "m8 1.596 1.786 3.62a1 1 0 0 0 .753.547l3.995.58-2.89 2.818a1 1 0 0 0-.288.885l.682 3.979-3.573-1.879a1 1 0 0 0-.93 0l-3.573 1.879.682-3.979a1 1 0 0 0-.287-.885L1.466 6.344l3.995-.58a1 1 0 0 0 .753-.548z"
  })));
};
export default SvgStarEmpty;